import Login from "../components/static/Login.vue"
import init from "../root_init"
init(Login)
